export default __webpack_public_path__ + "static/media/file_download.db3aea01.svg";